import React, { useEffect, useState } from "react";
import { FaStar, FaRegStar, FaQuoteLeft, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchAllReviews, fetchReviewSummary, addOrUpdateReview } from "../services/reviewService";
import AddReviewModal from "./review/AddReviewModal";
import "./TestimonialsSection.css";

const TestimonialsSection = () => {
  const [reviews, setReviews]   = useState([]);
  const [summary, setSummary]   = useState({ averageRating: 0, totalReviews: 0 });
  const [loading, setLoading]   = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate   = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  useEffect(() => {
    const load = async () => {
      try {
        const [r, s] = await Promise.all([fetchAllReviews(), fetchReviewSummary()]);
        setReviews(r.data || []);
        setSummary(s.data || { averageRating: 0, totalReviews: 0 });
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSubmit = async ({ rating, review }) => {
    await addOrUpdateReview({ rating, review });
    setShowModal(false);
  };

  return (
    <section className="ts-section">
      <h2 className="ts-title">What Our Learners Say</h2>

      <div className="ts-summary">
        {[1,2,3,4,5].map(i =>
          i <= Math.round(summary.averageRating)
            ? <FaStar key={i} size={20} color="#FFD700" />
            : <FaRegStar key={i} size={20} color="#FFD700" />
        )}
        <span className="ts-rating-score">{Number(summary.averageRating).toFixed(1)}</span>
        <span className="ts-rating-count">({summary.totalReviews} reviews)</span>
      </div>

      {loading && (
        <div className="ts-cards">
          {[1,2,3].map(i => <div key={i} className="ts-skeleton" />)}
        </div>
      )}

      {!loading && reviews.length === 0 && (
        <p className="ts-empty">No reviews yet. Be the first!</p>
      )}

      {!loading && reviews.length > 0 && (
        <>
          <div className="ts-cards">
            {reviews.map((r) => (
              <div key={r.id} className="ts-card">
                <FaQuoteLeft size={16} color="#028891" />
                <p className="ts-card-text">{r.review || "—"}</p>
                <div className="ts-card-stars">
                  {[1,2,3,4,5].map(i =>
                    i <= r.rating
                      ? <FaStar key={i} size={13} color="#FFD700" />
                      : <FaRegStar key={i} size={13} color="#FFD700" />
                  )}
                </div>
                <div className="ts-card-footer">
                  <span className="ts-card-name">
                    {r.userName || "User"}
                    {r.verified && <FaCheckCircle size={11} color="#019095" style={{ marginLeft: 5 }} />}
                  </span>
                  <span className="ts-card-date">
                    {new Date(r.createdAt).toLocaleDateString("en-IN", { month: "short", year: "numeric" })}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <p className="ts-scroll-hint">← Swipe to see more →</p>
        </>
      )}

      <div className="ts-actions">
        <button className="ts-btn ts-btn-primary" onClick={() => isLoggedIn ? setShowModal(true) : navigate("/login")}>
          ✍️ Add Your Review
        </button>
        <button className="ts-btn ts-btn-outline" onClick={() => navigate("/reviews")}>
          See All Reviews →
        </button>
      </div>

      <AddReviewModal open={showModal} onClose={() => setShowModal(false)} onSubmit={handleSubmit} />
    </section>
  );
};

export default TestimonialsSection;
